import React from 'react';
import { connect } from 'react-redux'
import { userSignOut } from 'actions/Auth';
import { Link } from 'react-router-dom';
import IntlMessages from 'util/IntlMessages';

class UserInfoPopup extends React.Component {
  render() {
    const { user_fnamn, user_lnamn, user_role, user_id } = this.props.authUser;
    let User_Role = "";
    switch (user_role) {
      case 0: User_Role = <IntlMessages id="user.Role.SAdmin" />; break;
      case 1: User_Role = <IntlMessages id="user.Role.Admin" />; break;
      case 3: User_Role = <IntlMessages id="user.Role.User" />; break;
      case 4: User_Role = <IntlMessages id="user.Role.Meetingbooker" />; break;
      case 2: User_Role = <IntlMessages id="user.Role.Backoffice" />; break;
      case 5: User_Role = <IntlMessages id="user.Role.Orderhandler" />; break;
      default: User_Role = <IntlMessages id="user.Role.Admin" />;
    }
    return (
      <div>
        <div className="user-profile">

          <div className="user-detail ml-2">
            <h4 className="user-name mb-0">{user_fnamn} {user_lnamn}</h4>
            <small>{User_Role}</small>
          </div>
        </div>
        <span className="jr-link dropdown-item text-muted">
          <Link className="text-muted" to={'/app/profile/' + user_id} onClick={() => this.props.toggle()}>
            <i className="zmdi zmdi-face zmdi-hc-fw mr-1" />
            <IntlMessages id="popup.profile" />
          </Link>
        </span>
        {
          parseInt(this.props.authUser.user_kanVaxla) === 1?
          <span className="jr-link dropdown-item text-muted">
            <Link className="text-muted" to='/app/Väljkonto/' onClick={() => this.props.toggle()}>
              <i className="zmdi zmdi-accounts-alt zmdi-hc-fw mr-1" />
              <IntlMessages id="page.Växlakonto" />
            </Link>
          </span>
          :""
        }
        {/*  */}
        <span className="jr-link dropdown-item text-muted" onClick={() => {
          console.log("Try to logout");
          this.props.userSignOut()
        }}>
          <i className="zmdi zmdi-sign-in zmdi-hc-fw mr-1" />
          <IntlMessages id="popup.logout" />
        </span>
      </div>
    );
  }
}
const mapStateToProps = ({ settings, auth }) => {
  const { authUser } = auth;
  return { authUser }
};
export default connect(mapStateToProps, { userSignOut })(UserInfoPopup);


